module.exports = __webpack_public_path__ + "img/register.5fb6becd.svg";